export default {
    email: null,
    tipo: 1,
    identity: 1,
    picture: null,
    name: null
}